import { lazy, Suspense } from "react";
import CircularLoader from "../customs/loader/main";
const Main = lazy(() => import("../components/settings/templateEditor/main"));

const Template = () => {
  return (
      <Suspense fallback={<CircularLoader />}>
        <Main />
      </Suspense>
  );
};

export default Template;
